import { useLazyQuery } from "@apollo/client";
import { gql } from "../../../types";

const GLOBAL_SEARCH = gql(/* GraphQL */ `
  query GlobalSearch($query: String!, $pagination: Pagination) {
    searchCompanies(query: $query) {
      count
      list {
        id
        name
        registeredNumber
      }
    }
    searchEmployees(query: $query, pagination: $pagination) {
      count
      list {
        id
        firstName
        lastName
        workEmail
        nationalId
        company {
          id
          name
        }
      }
    }
  }
`);

export const useGlobalSearch = () => {
  return useLazyQuery(GLOBAL_SEARCH);
};
